'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
var classNames = require('classnames');
var badge = require('@andes/badge');
var thumbnail = require('@andes/thumbnail');
var context = require('@andes/context');
var button = require('@andes/button');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
const namespace = 'andes-message';
const TYPE_NEUTRAL = 'neutral';
const TYPE_SUCCESS = 'success';
const TYPE_WARNING = 'warning';
const TYPE_ERROR = 'error';
const HIERARCHY_LOUD = 'loud';
const HIERARCHY_QUIET = 'quiet';
const ACTIONS_POSITION_RIGHT = 'right';
const ACTIONS_POSITION_BOTTOM = 'bottom';
var constants = {
  namespace,
  TYPE_NEUTRAL,
  TYPE_SUCCESS,
  TYPE_WARNING,
  TYPE_ERROR,
  HIERARCHY_LOUD,
  HIERARCHY_QUIET,
  ACTIONS_POSITION_RIGHT,
  ACTIONS_POSITION_BOTTOM
};
var constants$1 = constants;
var module$3 = "@andes/message";
var locale$2 = "en-US";
var translations$2 = {
  "andes-message\u0004cerrar": [null, "Close"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/message";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-message\u0004close": [null, "cerrar"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/message";
var locale = "pt-BR";
var translations = {
  "andes-message\u0004cerrar": [null, "Fechar"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const computeColorProps = _ref => {
  let {
    type,
    color
  } = _ref;
  if (color && color !== 'accent') return color;
  switch (type) {
    case 'neutral':
      return 'accent';
    case 'success':
      return 'green';
    case 'warning':
      return 'orange';
    case 'error':
      return 'red';
    default:
      return 'accent';
  }
};
var computeColorProp = computeColorProps;
var computeColorProps$1 = computeColorProp;
const Message = /*#__PURE__*/function () {
  const Message = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      actions,
      actionsPosition = constants$1.ACTIONS_POSITION_BOTTOM,
      children,
      className,
      closable = false,
      closeButtonLabel: _willDeprecate$closeButtonLabel,
      closeButtonSrLabel,
      color = 'accent',
      hierarchy = constants$1.HIERARCHY_LOUD,
      title,
      thumbnail: thumbnail$1,
      type: _willDeprecate$type,
      onClose,
      defaultVisible = true,
      visible,
      id
    } = _ref;
    const componentId = context.useId(id);
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const isControlled = React.useMemo(() => typeof visible !== 'undefined', []);
    const computedCloseButtonSrLabel = closeButtonSrLabel || _willDeprecate$closeButtonLabel;
    const computedColor = computeColorProps$1({
      type: _willDeprecate$type,
      color
    });
    const [uncontrolledVisible, setUncontrolledVisible] = React.useState(isControlled ? undefined : defaultVisible);
    const onCloseHandler = event => {
      if (!isControlled) setUncontrolledVisible(false);
      if (typeof onClose === 'function') onClose(event);
    };
    const renderActionButtons = () => /*#__PURE__*/React.isValidElement(actions) && /*#__PURE__*/React.cloneElement(actions, {
      actionsPosition,
      closable,
      hierarchy,
      title,
      color: computedColor,
      id: componentId
    });
    const messageClassnames = classNames__default["default"](className, constants$1.namespace, {
      ["".concat(constants$1.namespace, "--").concat(computedColor)]: computedColor,
      ["".concat(constants$1.namespace, "--").concat(hierarchy)]: hierarchy
    });
    const contentClassnames = classNames__default["default"]("".concat(constants$1.namespace, "__content"), {
      ["".concat(constants$1.namespace, "__content--untitled")]: !title
    });
    const closeButtonClassnames = classNames__default["default"]("".concat(constants$1.namespace, "__close-button"), {
      ["".concat(constants$1.namespace, "__close--").concat(computedColor)]: computedColor,
      ["".concat(constants$1.namespace, "__close--quiet")]: hierarchy === constants$1.HIERARCHY_QUIET,
      ["".concat(constants$1.namespace, "__close-in-line")]: actionsPosition === constants$1.ACTIONS_POSITION_RIGHT,
      ["".concat(constants$1.namespace, "__close--bottom")]: actionsPosition === constants$1.ACTIONS_POSITION_BOTTOM
    });
    const badgeClassNames = classNames__default["default"]("".concat(constants$1.namespace, "__badge"), {
      ["".concat(constants$1.namespace, "__badge--").concat(computedColor)]: hierarchy !== constants$1.HIERARCHY_QUIET && computedColor
    });
    const childrenClassnames = classNames__default["default"]("".concat(constants$1.namespace, "__text"), {
      ["".concat(constants$1.namespace, "__text--").concat(computedColor)]: computedColor,
      ["".concat(constants$1.namespace, "__text-inline-action")]: actionsPosition === constants$1.ACTIONS_POSITION_RIGHT
    });
    if (uncontrolledVisible === false || visible === false) return null;
    const NotificationComponent = /*#__PURE__*/_jsx__default["default"](badge.Pill, {
      className: badgeClassNames,
      size: "small",
      color: computedColor,
      id: "".concat(componentId, "-notification"),
      contentType: "icon"
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: messageClassnames,
      id: componentId,
      ref: ref
    }, hierarchy === constants$1.HIERARCHY_QUIET && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(constants$1.namespace, "__border-color--").concat(computedColor)
    }), thumbnail$1 ? /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(constants$1.namespace, "__thumbnail-container")
    }, void 0, /*#__PURE__*/_jsx__default["default"](thumbnail.Thumbnail, {
      id: "".concat(componentId, "-thumbnail"),
      className: "".concat(constants$1.namespace, "__thumbnail")
    }, void 0, thumbnail$1), NotificationComponent) : NotificationComponent, /*#__PURE__*/_jsx__default["default"]("div", {
      className: contentClassnames
    }, void 0, title && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(constants$1.namespace, "__title ").concat(constants$1.namespace, "__title--").concat(computedColor)
    }, void 0, title), /*#__PURE__*/_jsx__default["default"]("div", {
      className: childrenClassnames
    }, void 0, children, renderActionButtons())), closable && /*#__PURE__*/_jsx__default["default"]("button", {
      type: "button",
      className: closeButtonClassnames,
      onClick: onCloseHandler,
      "aria-label": computedCloseButtonSrLabel || i18n.pgettext(constants$1.namespace, 'close')
    }));
  });
  Message.displayName = 'Message';
  return Message;
}();
var Message$1 = Message;
const MessageActions = /*#__PURE__*/function () {
  const MessageActions = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      actionsPosition = constants$1.ACTIONS_POSITION_BOTTOM,
      closable = false,
      color = 'accent',
      hierarchy = constants$1.HIERARCHY_LOUD,
      primary,
      secondary,
      title,
      type: _willDeprecate$type,
      id
    } = _ref;
    const componentId = context.useId(id);
    const computedColor = computeColorProps$1({
      type: _willDeprecate$type,
      color
    });
    const buttonsContainerClassnames = classNames__default["default"]({
      ["".concat(constants$1.namespace, "__buttons-container")]: actionsPosition === constants$1.ACTIONS_POSITION_BOTTOM || title
    });
    const primaryButtonClassnames = classNames__default["default"]({
      ["".concat(constants$1.namespace, "__primary-button-closeable")]: actionsPosition === constants$1.ACTIONS_POSITION_RIGHT && closable,
      ["".concat(constants$1.namespace, "__primary-button-inline")]: actionsPosition === constants$1.ACTIONS_POSITION_RIGHT && !title,
      ["".concat(constants$1.namespace, "__primary-button--").concat(computedColor)]: hierarchy === constants$1.HIERARCHY_LOUD
    });
    const secondaryButtonClassnames = classNames__default["default"](["".concat(constants$1.namespace, "__secondary-button")], {
      ["".concat(constants$1.namespace, "__secondary-button--").concat(computedColor)]: hierarchy === constants$1.HIERARCHY_LOUD,
      ["".concat(constants$1.namespace, "__secondary-button--").concat(hierarchy)]: hierarchy === constants$1.HIERARCHY_LOUD
    });
    const getPrimaryAction = () => {
      if (primary !== null && primary !== void 0 && primary.text) {
        return /*#__PURE__*/_jsx__default["default"](button.Button, {
          size: "medium",
          className: primaryButtonClassnames,
          onClick: primary.onClick,
          href: primary.href,
          id: "".concat(componentId, "-message-button-primary")
        }, void 0, /*#__PURE__*/_jsx__default["default"]("span", {}, void 0, primary.text));
      }
      return null;
    };
    const getSecondaryAction = () => {
      const showSecondAction = (secondary === null || secondary === void 0 ? void 0 : secondary.text) && actionsPosition === constants$1.ACTIONS_POSITION_BOTTOM && ((secondary === null || secondary === void 0 ? void 0 : secondary.onClick) || (secondary === null || secondary === void 0 ? void 0 : secondary.href));
      const buttonHierarchy = hierarchy === 'quiet' && (secondary === null || secondary === void 0 ? void 0 : secondary.hierarchy) || 'transparent';
      if (showSecondAction) {
        return /*#__PURE__*/_jsx__default["default"](button.Button, {
          size: "medium",
          className: secondaryButtonClassnames,
          onClick: secondary.onClick,
          hierarchy: buttonHierarchy,
          href: secondary.href,
          id: "".concat(componentId, "-message-button-secondary")
        }, void 0, /*#__PURE__*/_jsx__default["default"]("span", {}, void 0, secondary.text));
      }
      return null;
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: buttonsContainerClassnames,
      ref: ref
    }, getPrimaryAction(), getSecondaryAction());
  });
  MessageActions.displayName = 'MessageActions';
  return MessageActions;
}();
var MessageActions$1 = MessageActions;
exports.Message = Message$1;
exports.MessageActions = MessageActions$1;
exports["default"] = Message$1;
